import { render, staticRenderFns } from "./IconChevronDoubleDownSolid.vue?vue&type=template&id=1ff03fce"
import script from "./IconChevronDoubleDownSolid.vue?vue&type=script&lang=js"
export * from "./IconChevronDoubleDownSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports